import axios from 'axios';

import ManageUsersService from './user';
import PaymentService from './payment';
import apiConfig from 'constants/apiConfig';
import SpouseService from './spouse';
import ChildrenService from './children';
import GuardianService from './guardian';
import BankService from './bank';
import PensionService from './pension';
import EmployeeService from './employee-benefit';
import StockService from './stock-share';
import BondService from './bond';
import PhysicalAssetService from './physical-asset';
import BeneficiaryService from './beneficiary';
import ExecutorService from './executor';
import TrusteeService from './trustee';
import GeneralService from './general';
import ManageStaffService from './admin/staff';
import ManageCustomerService from './admin/customer';
import ManageProspectService from './admin/prospect';

const baseurl: string = apiConfig?.base_url || '';

export const baseService = axios.create({
  baseURL: baseurl,
  withCredentials: true,
  timeout: 20000
});

export const services = {
  manageUsersService: new ManageUsersService(baseService),
  paymentService: new PaymentService(baseService),
  spouseService: new SpouseService(baseService),
  childrenService: new ChildrenService(baseService),
  guardianService: new GuardianService(baseService),
  bankService: new BankService(baseService),
  pensionService: new PensionService(baseService),
  employeeService: new EmployeeService(baseService),
  stockService: new StockService(baseService),
  bondService: new BondService(baseService),
  physicalAssetService: new PhysicalAssetService(baseService),
  beneficiaryService: new BeneficiaryService(baseService),
  executorService: new ExecutorService(baseService),
  trusteeService: new TrusteeService(baseService),
  generalService: new GeneralService(baseService),
  manageStaffService: new ManageStaffService(baseService),
  manageCustomerService: new ManageCustomerService(baseService),
  manageProspectService: new ManageProspectService(baseService)
};
